import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../pwa/service_worker_register"
import "../pwa/install_prompt"
import "../pwa/abrir_modal"

Rails.start()
Turbolinks.start()
ActiveStorage.start()
